import React, { useState, useEffect, useRef, Suspense, useMemo } from 'react';
import { Outlet, useNavigate, Link, useLocation } from 'react-router-dom';
import { useAuth } from './AuthContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import "../styles/Dashboard.css";

// Import SidePanel component
import SidePanel from './SidePanel';
import BarcodeGenerator from './BarcodeGenerator';
import AddCustomer from '../module_mechanics/mechanics_customer';
import CustomerList from '../module_mechanics/mechanics_customer_list';
import AddSupplier from '../module_mechanics/mechanics_Supplier';
import SupplierList from '../module_mechanics/mechanics_SuppliersList';
import AddProduct from '../module_mechanics/mechanics_Products';
import ProductsList from '../module_mechanics/mechanics_ProductsList';
import AddPurchase from '../module_mechanics/mechanics_Purchases';
import PurchasesList from '../module_mechanics/mechanics_PurchaseList';
import AddMecSales from '../module_mechanics/mechanics_Sell';
import MecSalesList from '../module_mechanics/mechanics_SellList';
import AddMecReturn from '../module_mechanics/mechanics_Return';
import MecReturnsList from '../module_mechanics/mechanics_ReturnList';
import MechanicsBarcode from '../module_mechanics/mechanics_BarcodeGenerator';
import AddEmployee from '../module_mechanics/mechanics_employees';
import MecEmployeeList from '../module_mechanics/mechanic_employeelist';
import ServiceForm from '../module_mechanics/mechanics_services';
import ServiceList from '../module_mechanics/mechanic_serviceshistory';
import TransactionsManager from '../module_mechanics/mechanics_transactions';
import MobchangeForm from '../module_mechanics/mechanics_mobchange';
import MobchangeList from '../module_mechanics/mechanics_mobchangelist';
import CarForm from '../module_mechanics/mechanics_car';
import CarList from '../module_mechanics/mechanics_carlist';
import ServiceNameList from '../module_mechanics/mechanics_serviceslist';

// Add NotificationForm import
import NotificationForm from '../pages/Notifications';

// Add all icon imports
import {
  faHome,
  faCar,
  faCog,
  faSignOutAlt,
  faBars,
  faSearch,
  faSun,
  faExchange,
  faKeyboard,
  faFileAlt,
  faMoon,
  faAddressBook,
  faFileExport,
  faChevronDown,
  faChartLine,
  faUserCog,
  faUser,
  faTimes,
  faBoxes,
  faMoneyBillWave,
  faUsers,
  faTruck,
  faChartBar,
  faClipboardList,
  faReceipt,
  faUserCircle,
  faExchangeAlt,
  faBoxOpen,
  faWarehouse,
  faCreditCard,
  faTasks,
  faChartPie,
  faUsersCog,
  faUserPlus,
  faBell,
  faQuestionCircle,
  faBolt,
  faTachometerAlt,
  faShoppingCart,
  faCalculator,
  faHandshake,
  faCheckCircle,
  faClock,
  faExclamationTriangle,
  faTimesCircle,
  faInfoCircle,
  faChevronRight,
  faDownload,
  faEye,
  faEdit,
  faTrash,
  faFilter,
  faRefresh,
  faPrint,
  faShare,
  faLock,
  faGlobe,
  faLanguage,
  faPalette,
  faExpand,
  faCompress,
  faCogs,
  faUserGroup,
  faBuilding,
  faMapMarkerAlt,
  faCalendar,
  faDatabase,
  faServer,
  faShieldAlt,
  faRobot,
  faChevronLeft,
  faCloud,
  faMobileAlt,
  faDesktop,
  faPlus,
  faUserTie,
  faListAlt,
  faShippingFast,
  faClipboardCheck,
  faFileInvoiceDollar,
  faFileUpload,
  faFileDownload,
  faChevronUp,
  faCrown,
  faTerminal,
  faCheck,
  faPaperPlane,
  faStar,
  faUserTag,
  faEnvelope,
  faTrashAlt,
  faStaffAesculapius,
  faPerson,
  faPersonHalfDress,
  faStore,
  faSyncAlt,
  faSpinner,
  faBuilding as faBusiness,
  faIdCard,
  faPhone,
  faStoreAlt,
  faShoppingBag,
  faHistory,
  faFileInvoice,
  faWallet,
  faCreditCard as faCreditCardAlt,
  faReceipt as faReceiptAlt,
  faBox,
  faCalendarAlt,
  faClipboardList as faClipboardListAlt,
  faPercentage,
  faTags,
  faComments,
  faHeadset,
  faTruck as faTruckDelivery,
  faCheckDouble,
  faStore as faSupplierStore,
  faClipboardList as faSupplierOrders,
  faFileInvoice as faSupplierInvoices,
  faCalendarCheck,
  faChartBar as faSupplierStats,
  faBoxes as faSupplierProducts,
  faMoneyBillWave as faSupplierPayments,
  faHandshake as faSupplierContract,
  faTruck as faSupplierDelivery,
  faWarehouse as faSupplierWarehouse,
  faPhone as faSupplierContact,
  faEnvelope as faSupplierMessage,
  faFileContract,
  faBoxOpen as faSupplierCatalog,
  faPercentage as faSupplierDiscount,
  faStar as faSupplierRating,
  faClock as faSupplierDeliveryTime,
  faCheckCircle as faSupplierVerified,
  faExclamationTriangle as faSupplierAlert,
  faListAlt as faSupplierPriceList,
  faShoppingCart as faSupplierPurchaseOrder,
  faFileExport as faSupplierExport,
  faFileImport as faSupplierImport,
  faChartLine as faSupplierTrend,
  faComments as faSupplierChat,
  faCalendarAlt as faSupplierSchedule,
  faMapMarkerAlt as faSupplierLocation,
  faBuilding as faSupplierCompany,
  faUserTie as faSupplierRepresentative,
  faFilePdf,
  faFileExcel,
  faFileCsv,
  faChartPie as faSupplierAnalytics,
  faTags as faSupplierCategories,
  faStarHalf as faSupplierReview,
  faTrophy as faSupplierAward,
  faCertificate,
  faShieldAlt as faSupplierCompliance,
  faTruckLoading,
  faPallet,
  faWeightHanging,
  faRulerCombined,
  faBoxesPacking,
  faBackward,
  faPeopleArrows,
  faGear,
  faArrowRightArrowLeft,
  faArrowRotateLeft,
  faCartShopping,
  faCartPlus,
  faListCheck,
  faFileLines,
  faQrcode,
  faIdCard as faIdCardIcon,
  faBriefcase,
  faHandHoldingDollar,
  faChartSimple,
  faGaugeHigh,
  faLayerGroup,
  faCube,
  faCubes,
  faArrowsSpin,
  faTruckArrowRight,
  faMoneyCheckDollar,
  faUserGear,
  faUsersLine,
  faBuildingUser,
  faTruckFast,
  faRotateLeft,
  faClipboard,
  faToolbox,
  faOilCan,
  faWrench,
  faGears,
  faEngine,
  faBatteryFull,
  faFan,
  faSnowplow,
  faScrewdriverWrench,
  faSparkles,
  faDroplet,
  faFireExtinguisher,
  faGauge,
  faSteeringWheel,
  faTire,
  faChargingStation,
  faRoad,
  faCarOn,
  faGasPump,
  faArrowTrendUp,
  faMoneyBills,
  faMoneyBillTransfer,
  faSubscript,
  faShop
} from '@fortawesome/free-solid-svg-icons';
import RootUsers from './RootUsers';
import FinancialSummary from '../module_mechanics/mechanics_financialsummary';
import SubscriptionList from './SubscriptionsHistory';
import Invoices from './root_invoices';
import ShopsManagement from './Shops';
import { FaForumbee } from 'react-icons/fa';
import InternshipForm from './internshipcert';

// Lazy load components
const DashboardHome = React.lazy(() => import('../module_mechanics/mechanics_DashHome'));

// ==============================================
// SHARED TRANSLATOR (SYNCED WITH LOGIN.JS)
// ==============================================

class InstantTranslator {
  constructor() {
    this.cache = new Map();
    this.preloadedLanguages = new Set(['en', 'ur', 'ar', 'es']);
    this.translationQueue = [];
    this.isTranslating = false;

    this.loadFromCache();
  }

  loadFromCache() {
    try {
      const cached = localStorage.getItem('ourzest_translations');
      if (cached) {
        const parsed = JSON.parse(cached);
        Object.entries(parsed).forEach(([key, value]) => {
          this.cache.set(key, value);
        });
      }
    } catch (e) {
      console.log("No cache found");
    }
  }

  saveToCache() {
    const cacheObj = {};
    this.cache.forEach((value, key) => {
      cacheObj[key] = value;
    });
    localStorage.setItem('ourzest_translations', JSON.stringify(cacheObj));
  }

  async translateAPI(text, targetLang) {
    const apis = [
      async () => {
        try {
          const response = await fetch('https://translate.argosopentech.com/translate', {
            method: 'POST',
            body: JSON.stringify({
              q: text,
              source: 'en',
              target: targetLang
            }),
            headers: { 'Content-Type': 'application/json' }
          });
          if (response.ok) {
            const data = await response.json();
            return data.translatedText;
          }
        } catch (e) { }
        return null;
      },

      async () => {
        try {
          const response = await fetch(
            `https://api.mymemory.translated.net/get?q=${encodeURIComponent(text)}&langpair=en|${targetLang}`
          );
          if (response.ok) {
            const data = await response.json();
            return data.responseData.translatedText;
          }
        } catch (e) { }
        return null;
      },

      async () => {
        const dict = {
          'ur': {
            'dashboard': 'ڈیش بورڈ',
            'welcome': 'خوش آمدید',
            'searchPlaceholder': 'ماڈیولز، رپورٹس، یا مدد تلاش کریں...',
            'notifications': 'نوٹیفیکیشنز',
            'markAllRead': 'سب پڑھے ہوئے نشان لگائیں',
            'viewAll': 'سب دیکھیں',
            'myProfile': 'میرا پروفائل',
            'settings': 'ترتیبات',
            'helpSupport': 'مدد اور تعاون',
            'logout': 'لاگ آؤٹ',
            'modules': 'ماڈیولز',
            'systemOnline': 'سسٹم آن لائن',
            'quickHelp': 'فوری مدد',
            'todayTasks': 'آج کے کام',
            'performance': 'کارکردگی',
            'pendingActions': 'زیر التواء کارروائیاں',
            'activeUsers': 'فعال صارفین',
            'loading': 'لوڈ ہو رہا ہے...',
            'theme': 'تھیم کا رنگ',
            'language': 'زبان',
            'custom': 'اپنی مرضی کا رنگ',
            'switchShops': 'شاپس تبدیل کریں',
            'availableShops': 'دستیاب شاپس',
            'loadingShops': 'شاپس لوڈ ہو رہی ہیں...',
            'noShopsAvailable': 'کوئی شاپ دستیاب نہیں',
            'refreshShops': 'شاپس ریفریش کریں',
            'role': 'رول',
            'close': 'بند کریں',
            'default': 'ڈیفالٹ'
          },
          'ar': {
            'dashboard': 'لوحة التحكم',
            'welcome': 'مرحبا بعودتك',
            'searchPlaceholder': 'البحث عن الوحدات أو التقارير أو المساعدة...',
            'notifications': 'الإشعارات',
            'markAllRead': 'تحديد الكل كمقروء',
            'viewAll': 'عرض الكل',
            'myProfile': 'ملفي الشخصي',
            'settings': 'الإعدادات',
            'helpSupport': 'المساعدة والدعم',
            'logout': 'تسجيل الخروج',
            'modules': 'الوحدات',
            'systemOnline': 'النظام يعمل',
            'quickHelp': 'مساعدة سريعة',
            'todayTasks': 'مهام اليوم',
            'performance': 'الأداء',
            'pendingActions': 'الإجراءات المعلقة',
            'activeUsers': 'المستخدمين النشطين',
            'loading': 'جاري التحميل...',
            'theme': 'لون السمة',
            'language': 'اللغة',
            'custom': 'لون مخصص',
            'switchShops': 'تبديل المتاجر',
            'availableShops': 'المتاجر المتاحة',
            'loadingShops': 'جاري تحميل المتاجر...',
            'noShopsAvailable': 'لا توجد متاجر متاحة',
            'refreshShops': 'تحديث المتاجر',
            'role': 'الدور',
            'close': 'إغلاق',
            'default': 'افتراضي'
          },
          'es': {
            'dashboard': 'Panel de Control',
            'welcome': 'Bienvenido',
            'searchPlaceholder': 'Buscar módulos, informes o ayuda...',
            'notifications': 'Notificaciones',
            'markAllRead': 'Marcar todo como leído',
            'viewAll': 'Ver todo',
            'myProfile': 'Mi Perfil',
            'settings': 'Configuración',
            'helpSupport': 'Ayuda y Soporte',
            'logout': 'Cerrar sesión',
            'modules': 'MÓDULOS',
            'systemOnline': 'Sistema en Línea',
            'quickHelp': 'Ayuda Rápida',
            'todayTasks': 'Tareas de Hoy',
            'performance': 'Rendimiento',
            'pendingActions': 'Acciones Pendientes',
            'activeUsers': 'Usuarios Activos',
            'loading': 'Cargando...',
            'theme': 'Color del Tema',
            'language': 'Idioma',
            'custom': 'Color Personalizado',
            'switchShops': 'Cambiar Tiendas',
            'availableShops': 'Tiendas Disponibles',
            'loadingShops': 'Cargando tiendas...',
            'noShopsAvailable': 'No hay tiendas disponibles',
            'refreshShops': 'Actualizar Tiendas',
            'role': 'Rol',
            'close': 'Cerrar',
            'default': 'Predeterminado'
          }
        };

        if (dict[targetLang] && dict[targetLang][text]) {
          return dict[targetLang][text];
        }
        return text;
      }
    ];

    for (const api of apis) {
      const result = await api();
      if (result) return result;
    }

    return text;
  }

  async translateText(text, targetLang) {
    if (targetLang === 'en') return text;

    const cacheKey = `${text}_${targetLang}`;

    if (this.cache.has(cacheKey)) {
      return this.cache.get(cacheKey);
    }

    const translated = await this.translateAPI(text, targetLang);

    this.cache.set(cacheKey, translated);
    this.saveToCache();

    return translated;
  }

  defaultTexts = {
    dashboard: 'Dashboard',
    welcome: 'Welcome',
    searchPlaceholder: 'Search modules, reports, or help...',
    notifications: 'Notifications',
    markAllRead: 'Mark all as read',
    viewAll: 'View All',
    myProfile: 'My Profile',
    settings: 'Settings',
    billings: 'Billings',
    managebillings: 'Manage Billings',
    profitloss: 'Profit Loss',
    helpSupport: 'Help & Support',
    logout: 'Logout',
    modules: 'MODULES',
    systemOnline: 'System Online',
    quickHelp: 'Quick Help',
    todayTasks: 'Today\'s Tasks',
    performance: 'Performance',
    pendingActions: 'Pending Actions',
    activeUsers: 'Active Users',
    loading: 'Loading...',
    theme: 'Theme Color',
    language: 'Language',
    custom: 'Custom Color',
    inventory: 'Inventory',
    sales: 'Sales',
    accounting: 'Accounting',
    hr: 'HR',
    crm: 'CRM',
    reports: 'Reports',
    addcustomer: 'Add Customer',
    customerlist: 'Customers List',
    neworder: 'New Order',
    orderslist: 'Orders List',
    purchases: 'Purchase',
    accontstatement: 'Account Statement',
    paydues: 'Pay Dues',
    statement: 'Statement',
    addsupplier: 'Add Supplier',
     settings: 'Settings',
     manageusers: 'Manage Users',
     financialsummary: 'Financial Summary',
    supplierlist: 'Suppliers List',
    products: 'Products',
    addproduct: 'Add Product',
    productslist: 'Products List',
    stock: 'Stock',
    warehouse: 'Warehouse',
    suppliers: 'Suppliers',
    orders: 'Orders',
    invoices: 'Invoices',
    customers: 'Customers',
    transactions: 'Transactions',
    cars: 'Cars',
    payments: 'Payments',
    employees: 'Employees',
    attendance: 'Attendance',
    payroll: 'Payroll',
    leads: 'Leads',
    contacts: 'Contacts',
    activities: 'Activities',
    analytics: 'Analytics',
    export: 'Export',
    general: 'General',
    users: 'Users',
    system: 'System',
    advanced_reports: 'Advanced Reports',
    discount_approval: 'Discount Approval',
    financial_audit: 'Financial Audit',
    confidential_salaries: 'Confidential Salaries',
    vip_clients: 'VIP Clients',
    executive_reports: 'Executive Reports',
    developer_tools: 'Developer Tools',
    confirm: 'Confirm',
    cancel: 'Cancel',
    save: 'Save',
    delete: 'Delete',
    edit: 'Edit',
    view: 'View',
    addNew: 'Add New',
    refresh: 'Refresh',
    filter: 'Filter',
    print: 'Print',
    success: 'Success',
    error: 'Error',
    warning: 'Warning',
    info: 'Info',
    pending: 'Pending',
    completed: 'Completed',
    inProgress: 'In Progress',
    sendNotification: 'Send Notification',
    newNotification: 'New Notification',
    noNotifications: 'No notifications',
    from: 'From',
    important: 'Important',
    allUsers: 'All Users',
    specificUsers: 'Specific Users',
    byRole: 'By Role',
    selectUsers: 'Select Users',
    selectRoles: 'Select Roles',
    title: 'Title',
    message: 'Message',
    type: 'Type',
    recipientType: 'Recipient Type',
    markAsImportant: 'Mark as Important',
    switchShops: 'Switch Shops',
    currentShop: 'Current Shop',
    availableShops: 'Available Shops',
    switchTo: 'Switch to',
    shop: 'Shop',
    role: 'Role',
    close: 'Close',
    default: 'Default',
    current: 'Current',
    business: 'Business',
    phone: 'Phone',
    address: 'Address',
    loadingShops: 'Loading shops...',
    noShopsAvailable: 'No shops available',
    refreshShops: 'Refresh Shops',
    quickSwitch: 'Quick Switch',
    switchNow: 'Switch Now',
    shopDetails: 'Shop Details',
    shopCode: 'Shop Code',
    shopRole: 'Shop Role',
    shopName: 'Shop Name',
    myDashboard: 'My Dashboard',
    placeOrder: 'Place Order',
    myOrders: 'My Orders',
    orderHistory: 'Order History',
    trackOrder: 'Track Order',
    myAccount: 'My Account',
    accountStatement: 'Account Statement',
    paymentDue: 'Payment Due',
    makePayment: 'Make Payment',
    paymentHistory: 'Payment History',
    creditLimit: 'Credit Limit',
    availableCredit: 'Available Credit',
    myProducts: 'My Products',
    favoriteProducts: 'Favorite Products',
    recentlyViewed: 'Recently Viewed',
    specialOffers: 'Special Offers',
    support: 'Support',
    raiseTicket: 'Raise Ticket',
    myTickets: 'My Tickets',
    contactSupport: 'Contact Support',
    shipping: 'Shipping',
    deliveryStatus: 'Delivery Status',
    returnRequests: 'Return Requests',
    wishlist: 'Wishlist',
    priceList: 'Price List',
    bulkOrder: 'Bulk Order',
    reorder: 'Reorder',
    invoiceHistory: 'Invoice History',
    paymentMethods: 'Payment Methods',
    customerSupport: 'Customer Support',
    orderTracking: 'Order Tracking',
    supplierDashboard: 'Supplier Dashboard',
    supplierOrders: 'Supplier Orders',
    supplierInvoices: 'Supplier Invoices',
    supplierPayments: 'Supplier Payments',
    supplierCatalog: 'Product Catalog',
    supplierPriceList: 'Price List',
    supplierContracts: 'Contracts',
    supplierDelivery: 'Delivery Management',
    supplierProfile: 'Supplier Profile',
    supplierProducts: 'My Products',
    supplierStock: 'Stock Management',
    supplierReturns: 'Returns',
    supplierAnalytics: 'Analytics',
    supplierMessages: 'Messages',
    supplierSupport: 'Support',
    supplierCompany: 'Company Info',
    supplierRepresentative: 'Representative',
    supplierLocation: 'Location',
    supplierCategories: 'Categories',
    supplierReviews: 'Reviews & Ratings',
    supplierAwards: 'Achievements',
    supplierCompliance: 'Compliance',
    supplierPurchaseOrders: 'Purchase Orders',
    supplierQuotations: 'Quotations',
    supplierShipments: 'Shipments',
    supplierDeliverySchedule: 'Delivery Schedule',
    supplierQualityControl: 'Quality Control',
    supplierCertificates: 'Certificates',
    supplierDiscounts: 'Discounts',
    supplierSpecialOffers: 'Special Offers',
    supplierNewProducts: 'New Products',
    supplierOutOfStock: 'Out of Stock',
    supplierLowStock: 'Low Stock',
    supplierOrderStatus: 'Order Status',
    supplierPaymentStatus: 'Payment Status',
    supplierDeliveryStatus: 'Delivery Status',
    supplierReturnStatus: 'Return Status',
    supplierVerified: 'Verified Supplier',
    supplierPremium: 'Premium Supplier',
    supplierGold: 'Gold Partner',
    supplierPlatinum: 'Platinum Partner',
    supplierPendingApproval: 'Pending Approval',
    supplierActive: 'Active',
    supplierInactive: 'Inactive',
    supplierSuspended: 'Suspended',
    supplierBlacklisted: 'Blacklisted',

    // --- MECHANICS MODULE MENUS & SUBMENUS ---
    carsaddition: 'Cars List',
    serviceslist: 'Services Names',
    servicesaddition: 'Services',
    transactionsmanager: 'Transactions',
    addstock: 'Add Stock',
    addproduct: 'Add Product',
    stocklist: 'Stock List',
    addsale: 'New Sale',
    saleslist: 'Sales List',
    addpurchase: 'New Purchase',
    purchaselist: 'Purchases List',
    returns: 'Returns',
    addreturn: 'New Return',
    returnlist: 'Return List',
    services: 'Car Services',
    newservice: 'New Service',
    serviceshistory: 'Services History',
    mobchange: 'Oil Change',
    addmobchange: 'Add Record',
    mobchangelist: 'Services History',
    addemployees: 'Add Employee',
    employeeslist: 'Employees List',
    barcode: 'Barcodes',
    barcodeprinting: 'Barcode Printing'
  };

  async getTranslations(lang) {
    if (lang === 'en') {
      return this.defaultTexts;
    }

    const translations = {};

    const allCached = Object.keys(this.defaultTexts).every(key => {
      const cacheKey = `${this.defaultTexts[key]}_${lang}`;
      return this.cache.has(cacheKey);
    });

    if (allCached) {
      Object.keys(this.defaultTexts).forEach(key => {
        const cacheKey = `${this.defaultTexts[key]}_${lang}`;
        translations[key] = this.cache.get(cacheKey);
      });
      return translations;
    }

    const promises = [];
    Object.entries(this.defaultTexts).forEach(([key, text]) => {
      const cacheKey = `${text}_${lang}`;
      if (this.cache.has(cacheKey)) {
        translations[key] = this.cache.get(cacheKey);
      } else {
        promises.push(
          this.translateText(text, lang).then(translated => {
            translations[key] = translated;
          })
        );
      }
    });

    if (promises.length > 0) {
      await Promise.all(promises);
      this.saveToCache();
    }

    return translations;
  }
}

const translator = new InstantTranslator();

const LANGUAGES = {
  en: { name: 'English', icon: '🇺🇸', dir: 'ltr' },
  ur: { name: 'اردو', icon: '🇵🇰', dir: 'rtl' },
  ar: { name: 'عربي', icon: '🇸🇦', dir: 'rtl' },
  es: { name: 'Español', icon: '🇪🇸', dir: 'ltr' }
};

const THEME_COLORS = [
  { name: 'Indigo', value: '#6366f1' },
  { name: 'Rose', value: '#f43f5e' },
  { name: 'Emerald', value: '#10b92f' },
  { name: 'Amber', value: '#f59e0b' },
  { name: 'Violet', value: '#8b5cf6' },
  { name: 'Cyan', value: '#06b6d4' },
  { name: 'Fuchsia', value: '#d946ef' },
  { name: 'Sky', value: '#0ea5e9' }
];

const ROLE_HIERARCHY = {
  'super_admin': 1,
  'admin_mechanicsap': 2,
  'manager_mechanicsap': 3,
  'user_mechanicsap': 4,
  'viewer_mechanics': 5,
};

const hasRoleAccess = (userRole, requiredRole) => {
  if (!userRole || !requiredRole) return false;

  if (requiredRole === 'all') return true;

  if (userRole === 'admin' || userRole === 'super_admin') return true;

  if (Array.isArray(requiredRole)) {
    return requiredRole.includes(userRole);
  }

  const userLevel = ROLE_HIERARCHY[userRole] || 999;
  const requiredLevel = ROLE_HIERARCHY[requiredRole] || 999;

  return userLevel <= requiredLevel;
};

const SPECIAL_USER_PERMISSIONS = {
  'etc': {
    specialMenus: ['reports'],
    specialSubmenus: {
      'reports': ['analytics', 'dashboard']
    }
  },
};

const hasSpecialAccess = (username, menuName, submenuName = null) => {
  if (!username || !SPECIAL_USER_PERMISSIONS[username]) return false;

  const userPerms = SPECIAL_USER_PERMISSIONS[username];

  if (submenuName) {
    if (userPerms.specialSubmenus['all']?.includes('all')) {
      return true;
    }

    const menuSubmenus = userPerms.specialSubmenus[menuName];
    if (menuSubmenus?.includes('all') || menuSubmenus?.includes(submenuName)) {
      return true;
    }
  } else {
    if (userPerms.specialMenus.includes('all')) {
      return true;
    }

    return userPerms.specialMenus.includes(menuName);
  }

  return false;
};

const SHOP_EXCLUSIONS = {
  0: {
    excludedMenus: ['reports', 'settings'],
    excludedSubmenus: {
      'customers': ['addcustomer'],
      'products': ['addproduct'],
      'purchases': ['purchases'],
      'sell': ['add sell'],
      'return': ['add return']
    },
  },
};

const hasShopAccess = (currentShopId, menuName, submenuName = null) => {
  if (!currentShopId) return true;

  const shopId = parseInt(currentShopId);
  const shopExclusion = SHOP_EXCLUSIONS[shopId];
  if (!shopExclusion) return true;

  if (shopExclusion.excludedMenus && shopExclusion.excludedMenus.includes(menuName)) {
    return false;
  }

  if (submenuName && shopExclusion.excludedSubmenus &&
    shopExclusion.excludedSubmenus[menuName] &&
    shopExclusion.excludedSubmenus[menuName].includes(submenuName)) {
    return false;
  }

  return true;
};

// Helper to determine dashboard component based on user role
const getDashboardComponent = (userRole) => {
  if (!userRole) return DashboardHome;
  if (userRole.includes('pos') || userRole === 'admin_mechanicsap' || userRole === 'manager_mechanicsap' || userRole === 'user_mechanicsap') {
    return DashboardHome;
  }
  return DashboardHome;
};

// ==============================================
// UPDATED MENU STRUCTURE WITH PROPER ICONS
// ==============================================

const COMPLETE_MENU_STRUCTURE = [
  {
    name: 'dashboard',
    displayName: 'Dashboard',
    icon: faGaugeHigh,
    component: (userRole) => getDashboardComponent(userRole)(),
    roles: ['all'],
    submenus: []
  },
   {
      name: 'shop',
      displayName: 'Create Shop',
      icon: faShop,
      roles: ['superadmin'],
      description: 'Manage Shops',
      submenus: [
        {
          name: 'shops',
          displayName: 'Create Shops',
          component: ShopsManagement,
          icon: faShop,
          roles: ['superadmin'],
        },
       
      ]
    },
   {
      name: 'billing',
      displayName: 'Billings',
      icon: faFileInvoice,
      roles: ['admin_mechanicsap'],
      description: 'Manage Settings',
      submenus: [
        {
          name: 'managebillings',
          displayName: 'Manage Billings',
          component: SubscriptionList,
          icon: faCrown,
          roles: ['admin_mechanicsap'],
        },
        {
          name: 'manageinvoices',
          displayName: 'Manage Invoices',
          component: Invoices,
          icon: faCrown,
          roles: ['admin_mechanicsap'],
        },
      ]
    },
   {
      name: 'Internship',
      displayName: 'Internship',
      icon: faGear,
      roles: ['superadmin'],
      description: 'Manage Internship Students Record',
      submenus: [
        {
          name: 'Form',
          displayName: 'Form',
          component: InternshipForm,
          icon: FaForumbee,
          roles: ['admin_mechanicsap'],
        },
      ]
    },
   {
      name: 'settings',
      displayName: 'Settings',
      icon: faGear,
      roles: ['admin_mechanicsap'],
      description: 'Manage Settings',
      submenus: [
        {
          name: 'manageusers',
          displayName: 'Manage Users',
          component: RootUsers,
          icon: faUsers,
          roles: ['admin_mechanicsap'],
        },
      ]
    },
];

const DashboardSuperAdmin = () => {
  const { user, logout, setUser, switchShop, currentShop } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  // State management
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [searchQuery, setSearchQuery] = useState('');

  // Real Notifications State
  const [realNotifications, setRealNotifications] = useState([]);
  const [unreadCount, setUnreadCount] = useState(0);
  const [showNotifications, setShowNotifications] = useState(false);
  const [showNotificationForm, setShowNotificationForm] = useState(false);
  const [showUserMenu, setShowUserMenu] = useState(false);
  const [showThemePicker, setShowThemePicker] = useState(false);
  const [showLanguagePicker, setShowLanguagePicker] = useState(false);
  const [darkMode, setDarkMode] = useState(false);
  const [activeMenu, setActiveMenu] = useState('dashboard');
  const [activeSubmenu, setActiveSubmenu] = useState('');
  const [searchResults, setSearchResults] = useState([]);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [fullscreen, setFullscreen] = useState(false);
  const [pollingInterval, setPollingInterval] = useState(null);
  const [loadingNotifications, setLoadingNotifications] = useState(false);
  const [translatedBusinessName, setTranslatedBusinessName] = useState('');

  // Refresh toast state
  const [refreshMessage, setRefreshMessage] = useState(null);

  // Breadcrumb State
  const [breadcrumbItems, setBreadcrumbItems] = useState([]);

  // Shop Switcher State
  const [showShopSwitcher, setShowShopSwitcher] = useState(false);
  const [userShops, setUserShops] = useState([]);
  const [loadingShops, setLoadingShops] = useState(false);
  const [hasMultipleShops, setHasMultipleShops] = useState(false);
  const [userBusinessName, setUserBusinessName] = useState('');
  const [userRole, setUserRole] = useState('');

  // Form content state
  const [formContent, setFormContent] = useState(null);

  // Multiple side panel states
  const [activeSidePanel, setActiveSidePanel] = useState(null);
  const [sidePanelTitle, setSidePanelTitle] = useState('');
  const [sidePanelComponent, setSidePanelComponent] = useState(null);
  const [sidePanelPosition, setSidePanelPosition] = useState(() => {
    return localStorage.getItem('side_panel_position') || 'right';
  });

  // Shortcuts visibility state
  const [showShortcuts, setShowShortcuts] = useState(false);

  // Shortcut Modal State
  const [shortcutModal, setShortcutModal] = useState({
    isOpen: false,
    title: '',
    component: null
  });

  // ==============================================
  // FIXED: SINGLE SOURCE OF TRUTH INITIALIZATION
  // ==============================================

  const [currentLanguage, setCurrentLanguage] = useState(() => {
    const savedLanguage = localStorage.getItem('ourzest_language');
    return LANGUAGES[savedLanguage] ? savedLanguage : 'en';
  });

  const [currentTheme, setCurrentTheme] = useState(() => {
    const savedTheme = localStorage.getItem('ourzest_theme');
    return savedTheme && /^#[0-9A-F]{6}$/i.test(savedTheme) ? savedTheme : '#8cd200';
  });

  const [translations, setTranslations] = useState({});
  const [translatedMenus, setTranslatedMenus] = useState([]);

  const notificationRef = useRef(null);
  const userMenuRef = useRef(null);
  const themePickerRef = useRef(null);
  const languagePickerRef = useRef(null);
  const searchRef = useRef(null);
  const mainContentRef = useRef(null);
  const shopSwitcherRef = useRef(null);
  const shortcutsRef = useRef(null);

  // Function to show refresh notification
  const showRefreshNotification = (message) => {
    setRefreshMessage(message);
    setTimeout(() => setRefreshMessage(null), 3000);
  };

  // Function to open shortcut modal
  const openShortcutModal = (title, component) => {
    setShortcutModal({
      isOpen: true,
      title: title,
      component: component
    });
    setShowShortcuts(false);
  };

  // Function to close shortcut modal
  const closeShortcutModal = () => {
    setShortcutModal({
      isOpen: false,
      title: '',
      component: null
    });
  };

  // Breadcrumb update function
  const updateBreadcrumbs = (menuName, submenuName = null) => {
    const items = [];

    // Always add Dashboard as first item
    items.push({
      name: 'dashboard',
      displayName: translations.dashboard || 'Dashboard',
      isClickable: true
    });

    // Add current menu if not dashboard
    if (menuName && menuName !== 'dashboard') {
      const menu = translatedMenus.find(m => m.name === menuName);
      if (menu) {
        items.push({
          name: menuName,
          displayName: menu.translatedName,
          isClickable: true
        });
      }
    }

    // Add submenu if exists
    if (submenuName) {
      const menu = translatedMenus.find(m => m.name === menuName);
      if (menu) {
        const submenu = menu.submenus.find(s => s.name === submenuName);
        if (submenu) {
          items.push({
            name: submenuName,
            displayName: submenu.translatedName,
            isClickable: false
          });
        }
      }
    }

    // For RTL, reverse the array so Dashboard appears on the right
    const isRTL = currentLanguage === 'ar' || currentLanguage === 'ur';
    if (isRTL && items.length > 1) {
      setBreadcrumbItems([...items].reverse());
    } else {
      setBreadcrumbItems(items);
    }
  };

  // Breadcrumb click handler
  const handleBreadcrumbClick = (item) => {
    if (item.isClickable) {
      if (item.name === 'dashboard') {
        handleMenuClick('dashboard');
      } else if (item.name === activeMenu) {
        // If clicking on current menu, just reset to menu level
        setActiveSubmenu('');
        updateBreadcrumbs(activeMenu, '');
        const menu = translatedMenus.find(m => m.name === activeMenu);
        if (menu?.component) {
          setFormContent(React.createElement(menu.component));
        }
      }
    }
  };

  // ==============================================
  // CTRL+R / CMD+R REFRESH HANDLER - PRESERVES MENU STATE
  // ==============================================
  useEffect(() => {
    const handleControlledRefresh = (event) => {
      if ((event.ctrlKey || event.metaKey) && event.key === 'r') {
        event.preventDefault();
        
        const currentState = {
          activeMenu: activeMenu,
          activeSubmenu: activeSubmenu,
          sidebarOpen: sidebarOpen,
          currentLanguage: currentLanguage,
          currentTheme: currentTheme,
          darkMode: darkMode,
          sidePanelPosition: sidePanelPosition
        };
        
        sessionStorage.setItem('dashboard_state_before_refresh', JSON.stringify(currentState));
        
        if (activeMenu && activeSubmenu) {
          const menu = translatedMenus.find(m => m.name === activeMenu);
          if (menu) {
            const submenu = menu.submenus.find(s => s.name === activeSubmenu);
            if (submenu?.component) {
              setFormContent(React.createElement(submenu.component, { key: Date.now() }));
            }
          }
        } else if (activeMenu && activeMenu !== 'dashboard') {
          const menu = translatedMenus.find(m => m.name === activeMenu);
          if (menu?.component) {
            setFormContent(React.createElement(menu.component, { key: Date.now() }));
          }
        } else {
          const DashboardComponent = getDashboardComponent(user?.role);
          setFormContent(<DashboardComponent key={Date.now()} />);
        }
        
        showRefreshNotification('Dashboard data refreshed successfully!');
      }
    };

    window.addEventListener('keydown', handleControlledRefresh);
    
    return () => {
      window.removeEventListener('keydown', handleControlledRefresh);
    };
  }, [activeMenu, activeSubmenu, sidebarOpen, currentLanguage, currentTheme, darkMode, sidePanelPosition, translatedMenus, user]);

  // Restore menu state after page refresh
  useEffect(() => {
    const savedState = sessionStorage.getItem('dashboard_state_before_refresh');
    if (savedState) {
      const { activeMenu: savedMenu, activeSubmenu: savedSubmenu, sidebarOpen: savedSidebarOpen } = JSON.parse(savedState);
      
      if (savedMenu) {
        setActiveMenu(savedMenu);
        setActiveSubmenu(savedSubmenu || '');
        setSidebarOpen(savedSidebarOpen !== undefined ? savedSidebarOpen : true);
        
        if (savedMenu === 'dashboard') {
          const DashboardComponent = getDashboardComponent(user?.role);
          setFormContent(<DashboardComponent />);
        } else {
          const menu = translatedMenus.find(m => m.name === savedMenu);
          if (menu) {
            if (savedSubmenu) {
              const submenu = menu.submenus.find(s => s.name === savedSubmenu);
              if (submenu?.component) {
                setFormContent(React.createElement(submenu.component));
              }
            } else if (menu.component) {
              setFormContent(React.createElement(menu.component));
            }
          }
        }
      }
      
      sessionStorage.removeItem('dashboard_state_before_refresh');
    }
  }, [user, translatedMenus]);

  // Listen for side panel position changes
  useEffect(() => {
    const handleSidePanelPosition = () => {
      const position = localStorage.getItem('side_panel_position') || 'right';
      setSidePanelPosition(position);
    };

    handleSidePanelPosition();
    window.addEventListener('storage', handleSidePanelPosition);

    return () => {
      window.removeEventListener('storage', handleSidePanelPosition);
    };
  }, []);

  // Translate business name when language or original name changes
  useEffect(() => {
    const translateBusinessName = async () => {
      const originalName = currentShop?.shop_name || user?.businessname || user?.shopname || 'Welcome!';
      if (currentLanguage === 'en') {
        setTranslatedBusinessName(originalName);
      } else {
        try {
          const translated = await translator.translateText(originalName, currentLanguage);
          setTranslatedBusinessName(translated);
        } catch (error) {
          console.error('Error translating business name:', error);
          setTranslatedBusinessName(originalName);
        }
      }
    };
    translateBusinessName();
  }, [currentLanguage, currentShop?.shop_name, user?.businessname, user?.shopname]);

  // Click outside handler for shortcuts panel
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (shortcutsRef.current && !shortcutsRef.current.contains(event.target)) {
        setShowShortcuts(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  // Function to toggle side panels
  const toggleSidePanel = (panelId, title, component) => {
    if (activeSidePanel === panelId) {
      setActiveSidePanel(null);
      setSidePanelTitle('');
      setSidePanelComponent(null);
    } else {
      setActiveSidePanel(panelId);
      setSidePanelTitle(title);
      setSidePanelComponent(component);
    }
  };

  // Toggle shortcuts panel
  const toggleShortcuts = () => {
    setShowShortcuts(!showShortcuts);
  };

  // Function to close all dropdowns
  const closeAllDropdowns = () => {
    setShowNotifications(false);
    setShowUserMenu(false);
    setShowThemePicker(false);
    setShowLanguagePicker(false);
    setShowShopSwitcher(false);

    if (isMobile) {
      document.body.style.overflow = 'auto';
    }
  };

  // ESC key handler
  const handleEscapeKey = (event) => {
    if (event.key === 'Escape') {
      const hasOpenDropdowns = showNotifications || showUserMenu || showThemePicker || 
                               showLanguagePicker || showShopSwitcher || showShortcuts ||
                               searchResults.length > 0 || activeSidePanel || shortcutModal.isOpen;
      
      if (hasOpenDropdowns) {
        closeAllDropdowns();
        setSearchResults([]);
        setShowShopSwitcher(false);
        setActiveSidePanel(null);
        setSidePanelTitle('');
        setSidePanelComponent(null);
        setShowShortcuts(false);
        if (shortcutModal.isOpen) {
          closeShortcutModal();
        }
      } else {
        setSidebarOpen(prevState => !prevState);
        
        if (isMobile) {
          setTimeout(() => {
            if (!sidebarOpen) {
              document.body.style.overflow = 'hidden';
            } else {
              document.body.style.overflow = 'auto';
            }
          }, 10);
        }
      }
    }
  };

  // Keyboard shortcut handler
  const handleKeyboardShortcut = (event) => {
    const userRole = user?.role || '';
    const isMechanicsUser = userRole.includes('mechanics') || userRole === 'admin_mechanicsap' || userRole === 'manager_mechanicsap' || userRole === 'user_mechanicsap';

    if (isMechanicsUser) {
      if (event.altKey && event.key === 'c') {
        event.preventDefault();
        openShortcutModal('Add Customer', <AddCustomer embedded={true} />);
      }
      if (event.altKey && event.key === 'l') {
        event.preventDefault();
        openShortcutModal('Customer List', <CustomerList embedded={true} />);
      }
      if (event.altKey && event.key === 'p') {
        event.preventDefault();
        openShortcutModal('Stock List', <ProductsList embedded={true} />);
      }
      if (event.altKey && event.key === 's') {
        event.preventDefault();
        openShortcutModal('New Sale', <AddMecSales embedded={true} />);
      }
      if (event.altKey && event.key === 'a') {
        event.preventDefault();
        openShortcutModal('Sales List', <MecSalesList embedded={true} />);
      }
      if (event.altKey && event.key === 'u') {
        event.preventDefault();
        openShortcutModal('New Purchase', <AddPurchase embedded={true} />);
      }
      if (event.altKey && event.key === 'r') {
        event.preventDefault();
        openShortcutModal('New Return', <AddMecReturn embedded={true} />);
      }
      if (event.altKey && event.key === 't') {
        event.preventDefault();
        openShortcutModal('Transactions', <TransactionsManager embedded={true} />);
      }
      if (event.altKey && event.key === 'e') {
        event.preventDefault();
        openShortcutModal('Add Employee', <AddEmployee embedded={true} />);
      }
      if (event.altKey && event.key === 'g') {
        event.preventDefault();
        openShortcutModal('Employees List', <MecEmployeeList embedded={true} />);
      }
      if (event.altKey && event.key === 'v') {
        event.preventDefault();
        openShortcutModal('Suppliers', <SupplierList embedded={true} />);
      }
      if (event.altKey && event.key === 'b') {
        event.preventDefault();
        openShortcutModal('Barcode Printing', <MechanicsBarcode embedded={true} />);
      }
      if (event.altKey && event.key === 'w') {
        event.preventDefault();
        openShortcutModal('New Service', <ServiceForm embedded={true} />);
      }
      if (event.altKey && event.key === 'h') {
        event.preventDefault();
        openShortcutModal('Services History', <ServiceList embedded={true} />);
      }
      if (event.altKey && event.key === 'o') {
        event.preventDefault();
        openShortcutModal('Add Oil Change Record', <MobchangeForm embedded={true} />);
      }
      if (event.altKey && event.key === 'm') {
        event.preventDefault();
        openShortcutModal('Oil Change History', <MobchangeList embedded={true} />);
      }
      if (event.altKey && event.key === 'k') {
        event.preventDefault();
        openShortcutModal('Cars List', <CarList embedded={true} />);
      }
      if (event.altKey && event.key === 'n') {
        event.preventDefault();
        openShortcutModal('Service Names', <ServiceNameList embedded={true} />);
      }
      if (event.altKey && event.key === 'd') {
        event.preventDefault();
        handleMenuClick('dashboard');
      }
    }
    
    if (event.altKey && event.key === 'h') {
      event.preventDefault();
      toggleShortcuts();
    }
  };

  useEffect(() => {
    const initializeDashboard = async () => {
      try {
        console.log('Initializing dashboard with saved preferences...');

        const theme = localStorage.getItem('ourzest_theme') || '#8cd200';
        console.log('Applying theme:', theme);
        applyTheme(theme);
        setCurrentTheme(theme);

        const language = localStorage.getItem('ourzest_language') || 'en';
        console.log('Applying language:', language);
        await handleLanguageChange(language, false);

        const trans = await translator.getTranslations(language);
        setTranslations(trans);

        const savedDarkMode = localStorage.getItem('ourzest_darkMode') === 'true';
        if (savedDarkMode) {
          setDarkMode(true);
          document.body.classList.add('dark-mode');
        }

        console.log('Dashboard initialized with theme:', theme, 'language:', language);

      } catch (error) {
        console.error('Error initializing dashboard:', error);
        applyTheme('#8cd200');
        await handleLanguageChange('en', false);
      }
    };

    initializeDashboard();

    const handleResize = () => {
      const mobile = window.innerWidth <= 768;
      setIsMobile(mobile);
      if (mobile) {
        setSidebarOpen(false);
      }
    };

    window.addEventListener('resize', handleResize);
    handleResize();

    const handleClickOutside = (event) => {
      if (searchRef.current && !searchRef.current.contains(event.target)) {
        setSearchResults([]);
      }
      if (notificationRef.current && !notificationRef.current.contains(event.target)) {
        setShowNotifications(false);
      }
      if (userMenuRef.current && !userMenuRef.current.contains(event.target)) {
        setShowUserMenu(false);
      }
      if (themePickerRef.current && !themePickerRef.current.contains(event.target)) {
        setShowThemePicker(false);
      }
      if (languagePickerRef.current && !languagePickerRef.current.contains(event.target)) {
        setShowLanguagePicker(false);
      }
      if (shopSwitcherRef.current && !shopSwitcherRef.current.contains(event.target)) {
        setShowShopSwitcher(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    document.addEventListener('keydown', handleEscapeKey);
    window.addEventListener('keydown', handleKeyboardShortcut);

    if (user?.username) {
      fetchNotifications();
      const interval = setInterval(fetchNotifications, 21600000);
      setPollingInterval(interval);
    }

    if (user?.id) {
      loadUserShops();
    }

    return () => {
      window.removeEventListener('resize', handleResize);
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('keydown', handleEscapeKey);
      window.removeEventListener('keydown', handleKeyboardShortcut);
      if (pollingInterval) clearInterval(pollingInterval);
    };
  }, []);

  useEffect(() => {
    const loadTranslationsAndMenus = async () => {
      try {
        console.log('Loading translations for language:', currentLanguage);
        const trans = await translator.getTranslations(currentLanguage);
        setTranslations(trans);

        const accessibleMenus = getAccessibleMenus();
        const translated = accessibleMenus.map(menu => ({
          ...menu,
          translatedName: trans[menu.name] || menu.displayName,
          submenus: menu.submenus.map(sub => ({
            ...sub,
            translatedName: trans[sub.name] || sub.displayName
          }))
        }));
        setTranslatedMenus(translated);
        console.log('Menus translated for:', currentLanguage);
      } catch (error) {
        console.error('Error loading translations:', error);
      }
    };

    loadTranslationsAndMenus();
  }, [currentLanguage, user]);

  // Update breadcrumbs when translations or active menu changes
  useEffect(() => {
    if (activeMenu) {
      updateBreadcrumbs(activeMenu, activeSubmenu);
    } else {
      updateBreadcrumbs('', '');
    }
  }, [translations, activeMenu, activeSubmenu]);

  const updateLanguageDirection = (langCode) => {
    const langData = LANGUAGES[langCode];
    if (langData) {
      console.log('Setting language direction to:', langData.dir);

      document.documentElement.removeAttribute('dir');
      document.documentElement.removeAttribute('lang');
      document.documentElement.classList.remove('rtl', 'ltr');

      document.body.removeAttribute('dir');
      document.body.classList.remove('rtl', 'ltr');

      document.documentElement.dir = langData.dir;
      document.documentElement.lang = langCode;
      document.documentElement.style.direction = langData.dir;
      document.documentElement.classList.add(langData.dir);

      document.body.dir = langData.dir;
      document.body.style.direction = langData.dir;
      document.body.classList.add(langData.dir);

      document.documentElement.style.setProperty('--direction', langData.dir);

      document.documentElement.offsetHeight;

      console.log('Language direction applied:', langData.dir);
    }
  };

  const handleLanguageChange = async (langCode, saveToStorage = true) => {
    console.log('Changing language to:', langCode);

    if (!LANGUAGES[langCode]) {
      console.error('Invalid language code:', langCode);
      langCode = 'en';
    }

    localStorage.setItem('ourzest_language', langCode);

    setCurrentLanguage(langCode);
    setShowLanguagePicker(false);

    updateLanguageDirection(langCode);

    if (user) {
      const updatedUser = { ...user, language: langCode };
      setUser(updatedUser);
      localStorage.setItem('user', JSON.stringify(updatedUser));
    }

    try {
      const trans = await translator.getTranslations(langCode);
      setTranslations(trans);

      const accessibleMenus = getAccessibleMenus();
      const translated = accessibleMenus.map(menu => ({
        ...menu,
        translatedName: trans[menu.name] || menu.displayName,
        submenus: menu.submenus.map(sub => ({
          ...sub,
          translatedName: trans[sub.name] || sub.displayName
        }))
      }));
      setTranslatedMenus(translated);

      const originalName = currentShop?.shop_name || user?.businessname || user?.shopname || 'Welcome!';
      if (langCode === 'en') {
        setTranslatedBusinessName(originalName);
      } else {
        try {
          const translated = await translator.translateText(originalName, langCode);
          setTranslatedBusinessName(translated);
        } catch (error) {
          console.error('Error translating business name:', error);
          setTranslatedBusinessName(originalName);
        }
      }

    } catch (error) {
      console.error('Error loading translations:', error);
    }

    setTimeout(() => {
      window.dispatchEvent(new Event('resize'));
    }, 100);
  };

  const applyTheme = (color) => {
    try {
      if (!color || !/^#[0-9A-F]{6}$/i.test(color)) {
        color = '#8cd200';
      }

      console.log('Applying theme color:', color);

      localStorage.setItem('ourzest_theme', color);
      setCurrentTheme(color);

      const hex = color.replace('#', '');
      const r = parseInt(hex.substring(0, 2), 16);
      const g = parseInt(hex.substring(2, 4), 16);
      const b = parseInt(hex.substring(4, 6), 16);

      const adjust = (amount) => {
        let newR = Math.max(0, Math.min(255, r + amount));
        let newG = Math.max(0, Math.min(255, g + amount));
        let newB = Math.max(0, Math.min(255, b + amount));
        return `#${newR.toString(16).padStart(2, '0')}${newG.toString(16).padStart(2, '0')}${newB.toString(16).padStart(2, '0')}`;
      };

      const darker = adjust(-40);
      const lighter = adjust(40);
      const shadow = `rgba(${r}, ${g}, ${b}, 0.1)`;

      document.documentElement.style.setProperty('--primary-color', color);
      document.documentElement.style.setProperty('--primary-dark', darker);
      document.documentElement.style.setProperty('--primary-light', lighter);
      document.documentElement.style.setProperty('--primary-shadow', shadow);
      document.documentElement.style.setProperty('--primary-color-rgb', `${r}, ${g}, ${b}`);

      if (user) {
        const updatedUser = { ...user, themeColor: color };
        setUser(updatedUser);
        localStorage.setItem('user', JSON.stringify(updatedUser));
      }

      console.log('Theme applied successfully');

    } catch (err) {
      console.error('Error applying theme:', err);
      applyTheme('#8cd200');
    }
  };

  const handleThemeChange = (color) => {
    if (!color || !/^#[0-9A-F]{6}$/i.test(color)) {
      color = '#8cd200';
    }

    console.log('Changing theme to:', color);

    localStorage.setItem('ourzest_theme', color);

    setCurrentTheme(color);
    setShowThemePicker(false);
    applyTheme(color);
  };

  const loadUserShops = async () => {
    if (!user?.id) return;

    setLoadingShops(true);
    try {
      console.log('Loading shops for user ID:', user.id);

      const roleResponse = await fetch('https://ourzestapp.online/oz_backend/root_users.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          action: 'get_user_shop_roles',
          user_id: user.id
        })
      });

      const roleData = await roleResponse.json();

      let shopsData = [];

      if (roleData.success && roleData.data && roleData.data.length > 0) {
        const shopPromises = roleData.data.map(async (shopRole) => {
          const shopResponse = await fetch('https://ourzestapp.online/oz_backend/shops.php', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              action: 'get_shop_details',
              shop_id: shopRole.shop_id
            })
          });

          const shopData = await shopResponse.json();

          if (shopData.status === 'success' && shopData.data) {
            return {
              ...shopData.data,
              shop_id: shopRole.shop_id,
              shop_role: shopRole.role,
              shop_name: shopData.data.shop_name || `Shop #${shopRole.shop_id}`,
              shop_code: shopData.data.shop_code,
              assigned_role: shopRole.role,
              role: shopRole.role,
              is_default: shopRole.shop_id === user.default_shop_id
            };
          } else {
            return {
              shop_id: shopRole.shop_id,
              shop_name: shopRole.shop_name || `Shop #${shopRole.shop_id}`,
              shop_code: shopRole.shop_code || '',
              shop_role: shopRole.role,
              assigned_role: shopRole.role,
              role: shopRole.role,
              is_default: shopRole.shop_id === user.default_shop_id
            };
          }
        });

        shopsData = await Promise.all(shopPromises);

        if (shopsData.length > 0) {
          const currentShopRole = shopsData.find(shop =>
            shop.shop_id === currentShop?.shop_id
          )?.shop_role || user.role;

          setUserRole(currentShopRole);
        }

        if (user.businessname) {
          setUserBusinessName(user.businessname);
        }

      }

      setUserShops(shopsData);
      setHasMultipleShops(shopsData.length > 1);

      if (shopsData.length > 0 && !currentShop) {
        const defaultShop = shopsData.find(shop => shop.is_default) || shopsData[0];
        if (defaultShop) {
          await handleShopSwitch(defaultShop, true);
        }
      }

    } catch (error) {
      console.error('Error loading user shops:', error);
    } finally {
      setLoadingShops(false);
    }
  };

  const handleShopSwitch = async (shop, isInitial = false) => {
    if (shop.shop_id === currentShop?.shop_id && !isInitial) {
      setShowShopSwitcher(false);
      return;
    }

    try {
      const newShop = {
        shop_id: shop.shop_id,
        shop_name: shop.shop_name || `Shop #${shop.shop_id}`,
        shop_code: shop.shop_code || '',
        shop_role: shop.shop_role || shop.role || user.role
      };

      const verifyResponse = await fetch('https://ourzestapp.online/oz_backend/root_users.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          action: 'get_user_shop_roles',
          user_id: user.id
        })
      });

      const verifyData = await verifyResponse.json();

      if (verifyData.success && verifyData.data) {
        const shopRole = verifyData.data.find(sr => sr.shop_id == shop.shop_id);

        if (!shopRole) {
          alert('Access denied: You do not have permission for this shop');
          return;
        }

        const updatedUser = {
          ...user,
          shop_id: shop.shop_id,
          shop_name: newShop.shop_name,
          shop_code: newShop.shop_code,
          role: shopRole.role,
          current_shop_role: shopRole.role
        };

        setUser(updatedUser);
        localStorage.setItem("user", JSON.stringify(updatedUser));
        localStorage.setItem("user_role", shopRole.role);
        localStorage.setItem("current_shop", JSON.stringify(newShop));

        console.log(`Successfully switched to ${newShop.shop_name} with role: ${shopRole.role}`);

        if (!isInitial) {
          setShowShopSwitcher(false);
          setTimeout(() => {
            window.location.reload();
          }, 500);
        }
      } else {
        await switchShop(shop.shop_id, shop.shop_name, shop.shop_code);
        if (!isInitial) {
          setShowShopSwitcher(false);
          setTimeout(() => {
            window.location.reload();
          }, 500);
        }
      }
    } catch (error) {
      console.error('Error switching shop:', error);
      alert('Error switching shop. Please try again.');
    }
  };

  const toggleShopSwitcher = () => {
    if (!showShopSwitcher) {
      loadUserShops();
    }
    setShowShopSwitcher(!showShopSwitcher);
    setShowUserMenu(false);
    setShowNotifications(false);
    setShowThemePicker(false);
    setShowLanguagePicker(false);

    if (isMobile && !showShopSwitcher) {
      document.body.style.overflow = 'hidden';
    } else if (isMobile) {
      document.body.style.overflow = 'auto';
    }
  };

  const toggleUserMenu = () => {
    const newState = !showUserMenu;
    setShowUserMenu(newState);
    setShowShopSwitcher(false);
    setShowNotifications(false);
    setShowThemePicker(false);
    setShowLanguagePicker(false);

    if (isMobile && newState) {
      document.body.style.overflow = 'hidden';
    } else if (isMobile) {
      document.body.style.overflow = 'auto';
    }
  };

  const getAccessibleMenus = () => {
    if (!user) return [];

    const userRole = user.role;
    const username = user.username || user.email?.split('@')[0];
    const currentShopId = currentShop?.shop_id;

    return COMPLETE_MENU_STRUCTURE.filter(menu => {
      const hasRoleAccessToMenu = hasRoleAccess(userRole, menu.roles);
      const hasSpecialMenuAccess = hasSpecialAccess(username, menu.name);
      const hasShopMenuAccess = hasShopAccess(currentShopId, menu.name);

      return (hasRoleAccessToMenu || hasSpecialMenuAccess) && hasShopMenuAccess;
    }).map(menu => {
      const accessibleSubmenus = menu.submenus.filter(submenu => {
        const hasRoleAccessToSubmenu = hasRoleAccess(userRole, submenu.roles);
        const hasSpecialSubmenuAccess = hasSpecialAccess(username, menu.name, submenu.name);
        const hasShopSubmenuAccess = hasShopAccess(currentShopId, menu.name, submenu.name);

        return (hasRoleAccessToSubmenu || hasSpecialSubmenuAccess) && hasShopSubmenuAccess;
      });

      return {
        ...menu,
        submenus: accessibleSubmenus
      };
    });
  };

  const handleLogout = () => {
    localStorage.removeItem('ourzest_darkMode');
    logout();
    navigate('/login');
  };

  const toggleSidebar = () => {
    const newState = !sidebarOpen;
    setSidebarOpen(newState);
    if (isMobile && newState) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }
  };

  // ==============================================
  // HANDLE MENU NAVIGATION FROM DASHBOARD HOME
  // ==============================================
  const handleMenuNavigation = (menuName, submenuName = null) => {
    if (submenuName) {
      // Navigate to a specific submenu
      setActiveMenu(menuName);
      setActiveSubmenu(submenuName);
      updateBreadcrumbs(menuName, submenuName);
      
      // Find and render the submenu component
      const menu = translatedMenus.find(m => m.name === menuName);
      if (menu) {
        const submenu = menu.submenus.find(s => s.name === submenuName);
        if (submenu?.component) {
          setFormContent(React.createElement(submenu.component));
        }
      }
    } else {
      // Navigate to a menu
      setActiveMenu(menuName);
      setActiveSubmenu('');
      updateBreadcrumbs(menuName, '');
      
      const menu = translatedMenus.find(m => m.name === menuName);
      if (menu?.component) {
        setFormContent(React.createElement(menu.component));
      }
    }
    
    // Close sidebar on mobile
    if (isMobile) {
      setSidebarOpen(false);
      document.body.style.overflow = 'auto';
    }
  };

  const handleMenuClick = (menuName) => {
    if (activeMenu === menuName) {
      setActiveMenu('');
      setActiveSubmenu('');
      setFormContent(null);
      updateBreadcrumbs('', '');
    } else {
      setActiveMenu(menuName);
      setActiveSubmenu('');
      updateBreadcrumbs(menuName, '');
      const menu = translatedMenus.find(m => m.name === menuName);
      if (menu?.component && menu.name !== 'dashboard') {
        setFormContent(React.createElement(menu.component));
      } else if (menuName === 'dashboard') {
        const DashboardComponent = getDashboardComponent(user?.role);
        setFormContent(<DashboardComponent 
          onNavigate={handleMenuNavigation}
          setFormContent={setFormContent}
          onBreadcrumbUpdate={updateBreadcrumbs}
        />);
      }
    }
    if (isMobile) {
      document.body.style.overflow = 'auto';
    }
  };

  const handleSubmenuClick = (submenuName) => {
    setActiveSubmenu(submenuName);
    updateBreadcrumbs(activeMenu, submenuName);
    const menu = translatedMenus.find(m => m.name === activeMenu);
    if (menu) {
      const submenu = menu.submenus.find(s => s.name === submenuName);
      if (submenu?.component) {
        setFormContent(React.createElement(submenu.component));
      }
    }
    if (isMobile) {
      setSidebarOpen(false);
      document.body.style.overflow = 'auto';
    }
  };

  const handleSearchChange = (e) => {
    const query = e.target.value;
    setSearchQuery(query);

    if (query.trim()) {
      const results = translatedMenus.flatMap(menu => {
        const menuMatches = menu.translatedName.toLowerCase().includes(query.toLowerCase());
        const submenuMatches = menu.submenus.filter(submenu =>
          submenu.translatedName.toLowerCase().includes(query.toLowerCase())
        );

        const menuResult = menuMatches ? [{
          type: 'menu',
          name: menu.name,
          translatedName: menu.translatedName,
          icon: menu.icon,
          accessible: true
        }] : [];

        const submenuResults = submenuMatches.map(submenu => ({
          type: 'submenu',
          menu: menu.name,
          menuName: menu.translatedName,
          name: submenu.name,
          translatedName: submenu.translatedName,
          icon: submenu.icon,
          accessible: true
        }));

        return [...menuResult, ...submenuResults];
      });
      setSearchResults(results.slice(0, 10));
    } else {
      setSearchResults([]);
    }
  };

  const getActiveComponent = () => {
    if (formContent) {
      return formContent;
    }

    const menu = translatedMenus.find(m => m.name === activeMenu);
    if (!menu) {
      const DashboardComponent = getDashboardComponent(user?.role);
      if (DashboardComponent === DashboardHome) {
        return <DashboardHome 
          onNavigate={handleMenuNavigation}
          setFormContent={setFormContent}
          onBreadcrumbUpdate={updateBreadcrumbs}
        />;
      }
      return <DashboardComponent />;
    }

    if (activeSubmenu) {
      const submenu = menu.submenus.find(s => s.name === activeSubmenu);
      if (submenu?.component) {
        return React.createElement(submenu.component);
      }
    }

    if (menu.component) {
      if (menu.name === 'dashboard') {
        const DashboardComponent = getDashboardComponent(user?.role);
        if (DashboardComponent === DashboardHome) {
          return <DashboardHome 
            onNavigate={handleMenuNavigation}
            setFormContent={setFormContent}
            onBreadcrumbUpdate={updateBreadcrumbs}
          />;
        }
        return <DashboardComponent />;
      }
      return React.createElement(menu.component);
    }

    const DashboardComponent = getDashboardComponent(user?.role);
    if (DashboardComponent === DashboardHome) {
      return <DashboardHome 
        onNavigate={handleMenuNavigation}
        setFormContent={setFormContent}
        onBreadcrumbUpdate={updateBreadcrumbs}
      />;
    }
    return <DashboardComponent />;
  };

  const getMenuDisplayName = (menuName) => {
    const menu = translatedMenus.find(m => m.name === menuName);
    return menu?.translatedName || menuName;
  };

  const handleButtonClick = (setter, currentState) => {
    const dropdowns = {
      notifications: setShowNotifications,
      userMenu: setShowUserMenu,
      themePicker: setShowThemePicker,
      languagePicker: setShowLanguagePicker
    };

    Object.values(dropdowns).forEach(dropdownSetter => {
      if (dropdownSetter !== setter) {
        dropdownSetter(false);
      }
    });

    setter(!currentState);

    if (isMobile && !currentState) {
      document.body.style.overflow = 'hidden';
    } else if (isMobile) {
      document.body.style.overflow = 'auto';
    }
  };

  const fetchNotifications = async () => {
    if (!user?.username) return;

    try {
      setLoadingNotifications(true);
      const authData = {
        user_id: user.id,
        username: user.username,
        role: user.role
      };
      const authToken = btoa(JSON.stringify(authData));

      const response = await fetch(`https://ourzestapp.online/oz_backend/notifications.php?action=list&limit=20`, {
        headers: {
          'Authorization': `Bearer ${authToken}`,
          'Content-Type': 'application/json'
        }
      });

      const data = await response.json();
      if (data.success) {
        const sortedNotifications = data.notifications.sort((a, b) => {
          if (a.is_read !== b.is_read) return a.is_read ? 1 : -1;
          return new Date(b.created_at) - new Date(a.created_at);
        });
        setRealNotifications(sortedNotifications);
        setUnreadCount(data.unread_count);
      }
    } catch (error) {
      console.error('Error fetching notifications:', error);
    } finally {
      setLoadingNotifications(false);
    }
  };

  const markAsRead = async (id) => {
    try {
      const authData = {
        user_id: user.id,
        username: user.username,
        role: user.role
      };
      const authToken = btoa(JSON.stringify(authData));

      const response = await fetch('https://ourzestapp.online/oz_backend/notifications.php', {
        method: 'PUT',
        headers: {
          'Authorization': `Bearer ${authToken}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ action: 'mark_read', id: id })
      });

      const data = await response.json();
      if (data.success) {
        setRealNotifications(prev =>
          prev.map(notif =>
            notif.id === id ? { ...notif, is_read: true } : notif
          )
        );
        setUnreadCount(prev => Math.max(0, prev - 1));
      }
    } catch (error) {
      console.error('Error marking as read:', error);
    }
  };

  const markAllAsRead = async () => {
    try {
      const authData = {
        user_id: user.id,
        username: user.username,
        role: user.role
      };
      const authToken = btoa(JSON.stringify(authData));

      const response = await fetch('https://ourzestapp.online/oz_backend/notifications.php', {
        method: 'PUT',
        headers: {
          'Authorization': `Bearer ${authToken}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ action: 'mark_all_read' })
      });

      const data = await response.json();
      if (data.success) {
        setRealNotifications(prev =>
          prev.map(notif => ({ ...notif, is_read: true }))
        );
        setUnreadCount(0);
      }
    } catch (error) {
      console.error('Error marking all as read:', error);
    }
  };

  const refreshNotifications = () => {
    fetchNotifications();
  };

  const toggleDarkMode = () => {
    const newDarkMode = !darkMode;
    setDarkMode(newDarkMode);
    localStorage.setItem('ourzest_darkMode', newDarkMode.toString());
    if (newDarkMode) {
      document.body.classList.add('dark-mode');
    } else {
      document.body.classList.remove('dark-mode');
    }

    window.dispatchEvent(new CustomEvent('darkModeToggled', {
      detail: { darkMode: newDarkMode }
    }));
  };

  const toggleFullscreen = () => {
    if (!fullscreen) {
      if (document.documentElement.requestFullscreen) {
        document.documentElement.requestFullscreen();
      } else if (document.documentElement.webkitRequestFullscreen) {
        document.documentElement.webkitRequestFullscreen();
      } else if (document.documentElement.msRequestFullscreen) {
        document.documentElement.msRequestFullscreen();
      }
      setFullscreen(true);
    } else {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen();
      }
      setFullscreen(false);
    }
  };

  const getNotificationIcon = (type) => {
    switch (type) {
      case 'success': return faCheckCircle;
      case 'warning': return faExclamationTriangle;
      case 'error': return faTimesCircle;
      case 'system': return faServer;
      default: return faInfoCircle;
    }
  };

  const getNotificationTypeClass = (type) => {
    switch (type) {
      case 'success': return 'success';
      case 'warning': return 'warning';
      case 'error': return 'error';
      case 'system': return 'system';
      default: return 'info';
    }
  };

  // Get shortcuts based on user role
  const getShortcuts = () => {
    const userRole = user?.role || '';
    const isMechanicsUser = userRole.includes('mechanics') || userRole === 'admin_mechanicsap' || userRole === 'manager_mechanicsap' || userRole === 'user_mechanicsap';
    
    if (isMechanicsUser) {
      return [
        { key: 'Alt + D', description: 'Dashboard' },
        { key: 'Alt + C', description: 'Add Customer' },
        { key: 'Alt + L', description: 'Customer List' },
        { key: 'Alt + P', description: 'Stock List' },
        { key: 'Alt + S', description: 'New Sale' },
        { key: 'Alt + A', description: 'Sales List' },
        { key: 'Alt + U', description: 'New Purchase' },
        { key: 'Alt + R', description: 'New Return' },
        { key: 'Alt + T', description: 'Transactions' },
        { key: 'Alt + E', description: 'Add Employee' },
        { key: 'Alt + G', description: 'Employees List' },
        { key: 'Alt + V', description: 'Suppliers List' },
        { key: 'Alt + B', description: 'Barcode Printing' },
        { key: 'Alt + W', description: 'New Service' },
        { key: 'Alt + H', description: 'Services History' },
        { key: 'Alt + O', description: 'Add Oil Change Record' },
        { key: 'Alt + M', description: 'Oil Change History' },
        { key: 'Alt + K', description: 'Cars List' },
        { key: 'Alt + N', description: 'Service Names List' },
        { key: 'Ctrl + R / Cmd + R', description: 'Refresh Dashboard Data (Preserves Menu)' },
        { key: 'Alt + H', description: 'Toggle Shortcuts Panel' }
      ];
    }
    
    return [
      { key: 'Alt + D', description: 'Dashboard' },
      { key: 'Ctrl + R / Cmd + R', description: 'Refresh Dashboard Data (Preserves Menu)' },
      { key: 'Alt + H', description: 'Toggle Shortcuts' }
    ];
  };

  const shortcuts = getShortcuts();

  return (
    <div className={`dashboard-container ${darkMode ? 'dark-mode' : ''} ${sidebarOpen ? 'sidebar-open' : 'sidebar-closed'} ${LANGUAGES[currentLanguage]?.dir || 'ltr'}`}>
      {/* Top Navigation Bar */}
      <nav className="top-navbar">
        <div className="nav-left">
          <button className="sidebar-toggle" onClick={toggleSidebar} aria-label="Toggle sidebar">
            <FontAwesomeIcon icon={faBars} />
          </button>
          <div className="animated-business-name desktop-only-business">
            <span className="typewriter-text" dir="auto">
              {translatedBusinessName || currentShop?.shop_name || user?.businessname || user?.shopname || 'Welcome!'}
            </span>
            <span className="typewriter-cursor"></span>
          </div>
        </div>

        {/* Centered Breadcrumb */}
        <div className="nav-center">
          <div className="breadcrumb-container desktop-only">
            {breadcrumbItems.length > 0 && (
              <div className="breadcrumb-wrapper">
                {breadcrumbItems.map((item, index) => (
                  <React.Fragment key={index}>
                    {index > 0 && (
                      <span className="breadcrumb-separator">
                        <FontAwesomeIcon icon={faChevronRight} />
                      </span>
                    )}
                    <span
                      className={`breadcrumb-item ${item.isClickable ? 'clickable' : ''}`}
                      onClick={() => item.isClickable && handleBreadcrumbClick(item)}
                      style={{
                        color: item.isClickable ? 'var(--primary-color)' : 'var(--text-secondary)',
                        cursor: item.isClickable ? 'pointer' : 'default'
                      }}
                    >
                      {item.displayName}
                    </span>
                  </React.Fragment>
                ))}
              </div>
            )}
          </div>
        </div>

        <div className="nav-right">
          {/* Shortcuts Toggle Button */}
          <button
            className={`nav-btn shortcuts-toggle ${showShortcuts ? 'active' : ''}`}
            onClick={toggleShortcuts}
            title="Keyboard Shortcuts (Alt+H)"
          >
            <FontAwesomeIcon icon={faKeyboard} />
          </button>

          <button className="nav-btn" onClick={toggleFullscreen} title={fullscreen ? 'Exit Fullscreen' : 'Fullscreen'}>
            <FontAwesomeIcon icon={fullscreen ? faCompress : faExpand} />
          </button>

          <button className="nav-btn" onClick={toggleDarkMode} title={darkMode ? 'Light Mode' : 'Dark Mode'}>
            <FontAwesomeIcon icon={darkMode ? faSun : faMoon} />
          </button>

          <div className="theme-picker-container" ref={themePickerRef}>
            <button className="nav-btn" onClick={() => handleButtonClick(setShowThemePicker, showThemePicker)} title="Theme Color">
              <FontAwesomeIcon icon={faPalette} />
            </button>

            {showThemePicker && (
              <div className="theme-picker-dropdown">
                <div className="theme-picker-header"><h4>{translations.theme || 'Theme Color'}</h4></div>
                <div className="theme-presets-grid">
                  {THEME_COLORS.map((color) => (
                    <button key={color.value} className={`theme-preset ${currentTheme === color.value ? 'active' : ''}`} style={{ backgroundColor: color.value }} onClick={() => handleThemeChange(color.value)} title={color.name} />
                  ))}
                </div>
                <div className="custom-theme-input">
                  <input type="color" value={currentTheme} onChange={(e) => handleThemeChange(e.target.value)} />
                  <span>{translations.custom || 'Custom Color'}</span>
                </div>
              </div>
            )}
          </div>

          <div className="language-picker-container" ref={languagePickerRef}>
            <button className="nav-btn" onClick={() => handleButtonClick(setShowLanguagePicker, showLanguagePicker)} title={translations.language || 'Language'}>
              <FontAwesomeIcon icon={faLanguage} />
              <span className="current-lang-flag">{LANGUAGES[currentLanguage]?.icon}</span>
            </button>

            {showLanguagePicker && (
              <div className="language-dropdown">
                <div className="language-picker-header"><h4>{translations.language || 'Language'}</h4></div>
                <div className="language-options">
                  {Object.entries(LANGUAGES).map(([key, lang]) => (
                    <div key={key} className={`language-option ${currentLanguage === key ? 'active' : ''}`} onClick={() => handleLanguageChange(key)}>
                      <span className="lang-flag">{lang.icon}</span>
                      <span className="lang-name">{lang.name}</span>
                      {currentLanguage === key && <FontAwesomeIcon icon={faCheckCircle} className="check-icon" />}
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>

          <div className="notification-container" ref={notificationRef}>
            <button className="nav-btn notification-btn" onClick={() => handleButtonClick(setShowNotifications, showNotifications)}>
              <FontAwesomeIcon icon={faBell} />
              {unreadCount > 0 && <span className="notification-badge">{unreadCount}</span>}
            </button>

            {showNotifications && (
              <div className="notification-dropdown">
                <div className="notification-header">
                  <h4>{translations.notifications || 'Notifications'}</h4>
                  <div className="notification-actions">
                    <button className="refresh-btn" onClick={refreshNotifications} disabled={loadingNotifications}>
                      <FontAwesomeIcon icon={faRefresh} spin={loadingNotifications} />
                    </button>
                    {(user?.role === 'admin' || user?.role === 'super_admin' || user?.role === 'admin_pos' || user?.role?.includes('supplier')) && (
                      <button className="send-notification-btn" onClick={() => { setShowNotificationForm(true); setShowNotifications(false); }}>
                        <FontAwesomeIcon icon={faPaperPlane} />
                      </button>
                    )}
                    <button className="mark-all-read" onClick={markAllAsRead} disabled={unreadCount === 0}>
                      {translations.markAllRead || 'Mark all as read'}
                    </button>
                  </div>
                </div>
                <div className="notification-list">
                  {loadingNotifications ? (
                    <div className="loading-notifications"><div className="spinner-small"></div><p>Loading notifications...</p></div>
                  ) : realNotifications.length === 0 ? (
                    <div className="no-notifications"><FontAwesomeIcon icon={faBell} /><p>{translations.noNotifications || 'No notifications'}</p></div>
                  ) : (
                    realNotifications.slice(0, 10).map((notification) => (
                      <div key={notification.id} className={`notification-item ${notification.is_read ? 'read' : 'unread'} ${getNotificationTypeClass(notification.notification_type)}`} onClick={() => markAsRead(notification.id)}>
                        <div className="notification-icon"><FontAwesomeIcon icon={getNotificationIcon(notification.notification_type)} /></div>
                        <div className="notification-content">
                          <div className="notification-header-row"><h5>{notification.title}</h5><div className="notification-actions-right">{notification.is_important && <FontAwesomeIcon icon={faStar} className="important-icon" />}</div></div>
                          <p>{notification.message}</p>
                          <div className="notification-footer-row"><span className="notification-time">{notification.time_ago || notification.created_at}</span>{notification.sender_display_name && notification.sender_display_name !== 'System' && <span className="notification-sender">{translations.from || 'From'}: {notification.sender_display_name}</span>}</div>
                        </div>
                        {!notification.is_read && <div className="unread-dot"></div>}
                      </div>
                    ))
                  )}
                </div>
                {realNotifications.length > 0 && (
                  <div className="notification-footer"><Link to="/dashboard/notifications" onClick={() => setShowNotifications(false)}>{translations.viewAll || 'View All'} ({realNotifications.length})</Link></div>
                )}
              </div>
            )}
          </div>

          <div className="user-container" ref={userMenuRef}>
            {hasMultipleShops && user?.role !== 'customer' && (
              <div className="shop-switcher-wrapper" ref={shopSwitcherRef}>
                <button className="shop-switcher-btn" onClick={toggleShopSwitcher} title={`${translations.switchShops || 'Switch Shops'} (${userShops.length} ${translations.availableShops || 'available'})`}>
                  {loadingShops ? <FontAwesomeIcon icon={faSpinner} className="shop-icon loading" spin /> : <><FontAwesomeIcon icon={faStore} className="shop-icon" /><FontAwesomeIcon icon={faExchangeAlt} className="switch-icon" /></>}
                  {userShops.length > 0 && <span className="shop-count-badge">{userShops.length}</span>}
                </button>

                {showShopSwitcher && (
                  <>
                    <div className="shop-switcher-overlay" onClick={() => setShowShopSwitcher(false)} />
                    <div className="shop-switcher-dropdown">
                      <div className="shop-switcher-header"><h4>{translations.switchShops || 'Switch Shops'}</h4>{isMobile && <button className="close-dropdown-btn" onClick={() => setShowShopSwitcher(false)}><FontAwesomeIcon icon={faTimes} /></button>}</div>
                      {loadingShops ? (
                        <div className="shop-switcher-loading"><FontAwesomeIcon icon={faSpinner} spin /><p>{translations.loadingShops || 'Loading shops...'}</p></div>
                      ) : userShops.length === 0 ? (
                        <div className="no-shops-message"><FontAwesomeIcon icon={faStore} /><p>{translations.noShopsAvailable || 'No shops available'}</p><button className="refresh-shops-btn" onClick={loadUserShops}><FontAwesomeIcon icon={faRefresh} /> {translations.refreshShops || 'Refresh Shops'}</button></div>
                      ) : (
                        <>
                          <div className="shop-switcher-list">
                            {userShops.map((shop) => (
                              <div key={shop.shop_id} className={`shop-switcher-item ${shop.shop_id === currentShop?.shop_id ? 'active' : ''} ${shop.is_default ? 'default-shop' : ''}`} onClick={() => handleShopSwitch(shop)}>
                                <div className="shop-item-icon"><FontAwesomeIcon icon={shop.is_default ? faHome : faStore} /></div>
                                <div className="shop-item-details">
                                  <div className="shop-item-header"><h5 className="shop-name">{shop.shop_name}{shop.is_default && <span className="default-badge">{translations.default || 'Default'}</span>}</h5><div className="shop-actions">{shop.shop_role && <span className="shop-role-badge">{shop.shop_role.replace('_', ' ')}</span>}</div></div>
                                  <div className="shop-additional-info">{shop.phone && <p className="shop-phone"><FontAwesomeIcon icon={faPhone} /> {shop.phone}</p>}</div>
                                </div>
                                {shop.shop_id === currentShop?.shop_id && <FontAwesomeIcon icon={faCheck} className="current-indicator" />}
                              </div>
                            ))}
                          </div>
                        </>
                      )}
                      <div className="shop-switcher-footer"><div className="footer-info"><span>{translations.role || 'Role'}: <strong>{userRole || user?.role}</strong></span></div>{!isMobile && <button className="close-switcher-btn" onClick={() => setShowShopSwitcher(false)}>{translations.close || 'Close'}</button>}</div>
                    </div>
                  </>
                )}
              </div>
            )}

            <button className="user-btn" onClick={toggleUserMenu}>
              <div className="user-avatar">{user?.fullname?.charAt(0) || user?.username?.charAt(0) || user?.businessname?.charAt(0) || 'U'}</div>
              <span className="user-name">{user?.fullname || user?.businessname || user?.username}</span>
            </button>

            {showUserMenu && (
              <div className="user-dropdown">
                <div className="user-info">
                  {isMobile && <button className="close-dropdown-btn" onClick={() => setShowUserMenu(false)}><FontAwesomeIcon icon={faTimes} /></button>}
                  <div className="user-avatar-large">{user?.fullname?.charAt(0) || user?.username?.charAt(0) || user?.businessname?.charAt(0) || 'U'}</div>
                  <div className="user-details">
                    <h4>{user?.fullname || user?.businessname || user?.username}</h4>
                    <p className="user-role"><FontAwesomeIcon icon={faIdCard} /> {user?.role?.toUpperCase()}{user?.role === 'customer' && <span className="customer-badge-large">Customer Account</span>}{user?.role?.includes('supplier') && <span className="supplier-badge-large">{user?.role === 'supplier_platinum' && '★ Platinum Supplier'}{user?.role === 'supplier_gold' && '★★ Gold Supplier'}{user?.role === 'supplier_premium' && '★★★ Premium Supplier'}{user?.role === 'supplier' && 'Supplier Account'}</span>}</p>
                    <p className="user-email"><FontAwesomeIcon icon={faEnvelope} /> {user?.email || 'No email'}</p>
                    {currentShop && user?.role !== 'customer' && (<div className="current-shop-info"><div><strong>{currentShop.shop_name || `Shop #${currentShop.shop_id}`}</strong></div></div>)}
                    {hasMultipleShops && user?.role !== 'customer' && (<button className="switch-from-menu-btn" onClick={() => { setShowUserMenu(false); toggleShopSwitcher(); }}><FontAwesomeIcon icon={faExchangeAlt} /> {translations.switchShops || 'Switch Shops'}</button>)}
                  </div>
                </div>
                <div className="user-menu">
                  {user?.role === 'customer' && (<><Link to="/dashboard/my-profile" className="menu-item" onClick={closeAllDropdowns}><FontAwesomeIcon icon={faUser} /><span>{translations.myProfile || 'My Profile'}</span></Link><Link to="/dashboard/my-account" className="menu-item" onClick={closeAllDropdowns}><FontAwesomeIcon icon={faWallet} /><span>{translations.myAccount || 'My Account'}</span></Link></>)}
                  {user?.role?.includes('supplier') && (<><Link to="/dashboard/supplier-profile" className="menu-item" onClick={closeAllDropdowns}><FontAwesomeIcon icon={faBuilding} /><span>{translations.supplierProfile || 'Supplier Profile'}</span></Link><Link to="/dashboard/supplier-company" className="menu-item" onClick={closeAllDropdowns}><FontAwesomeIcon icon={faBusiness} /><span>{translations.supplierCompany || 'Company Info'}</span></Link></>)}
                  <Link to="/dashboard/help" className="menu-item" onClick={closeAllDropdowns}><FontAwesomeIcon icon={faQuestionCircle} /><span>{translations.helpSupport || 'Help & Support'}</span></Link>
                  <div className="menu-divider"></div>
                  <button className="menu-item logout-btn" onClick={handleLogout}><FontAwesomeIcon icon={faSignOutAlt} /><span>{translations.logout || 'Logout'}</span></button>
                </div>
              </div>
            )}
          </div>
        </div>
      </nav>

      <aside className="sidebar">
        <div className="sidebar-header">
          <h3>{user?.role === 'customer' ? (translations.customerPortal || 'CUSTOMER PORTAL') : user?.role?.includes('supplier') ? (translations.supplierPortal || 'SUPPLIER PORTAL') : (translations.modules || 'MODULES')}</h3>
          <div className="header-right"><span className="module-count">{translatedMenus.length}</span>{isMobile && (<button className="sidebar-close-mobile" onClick={toggleSidebar}><FontAwesomeIcon icon={faTimes} /></button>)}</div>
        </div>
        <div className="sidebar-content">
          <div className="main-nav">
            <div className={`sidebar-item ${activeMenu === 'dashboard' ? 'active' : ''}`} onClick={() => handleMenuClick('dashboard')}>
              <div className="sidebar-icon"><FontAwesomeIcon icon={faGaugeHigh} /></div>
              <span className="sidebar-text">{user?.role === 'customer' ? (translations.myDashboard || 'My Dashboard') : user?.role?.includes('supplier') ? (translations.supplierDashboard || 'Supplier Dashboard') : (translations.dashboard || 'Dashboard')}</span>
              {activeMenu === 'dashboard' && <div className="active-indicator"></div>}
            </div>
            {translatedMenus.filter(menu => menu.name !== 'dashboard').map((menu) => (
              <div key={menu.name} className="menu-wrapper">
                <div className={`sidebar-item ${activeMenu === menu.name ? 'active' : ''}`} onClick={() => handleMenuClick(menu.name)}>
                  <div className="sidebar-icon"><FontAwesomeIcon icon={menu.icon} /></div>
                  <span className="sidebar-text">{menu.translatedName}</span>
                  {menu.submenus.length > 0 && <FontAwesomeIcon icon={activeMenu === menu.name ? faChevronUp : faChevronDown} className="dropdown-icon" />}
                  {activeMenu === menu.name && <div className="active-indicator"></div>}
                </div>
                {activeMenu === menu.name && menu.submenus.length > 0 && (
                  <div className="submenu-container">
                    {menu.submenus.map((submenu) => (
                      <div key={submenu.name} className={`submenu-item ${activeSubmenu === submenu.name ? 'active' : ''}`} onClick={() => handleSubmenuClick(submenu.name)}>
                        <FontAwesomeIcon icon={submenu.icon} className="submenu-icon" />
                        <span className="submenu-text">{submenu.translatedName}</span>
                        {submenu.specialUsers?.includes(user?.username) && <span className="special-indicator" title="Special Access">★</span>}
                        {activeSubmenu === submenu.name && <div className="submenu-indicator"></div>}
                      </div>
                    ))}
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
        <div className="sidebar-footer">
          <div className="system-status"><div className="status-indicator online"></div><span>{translations.systemOnline || 'System Online'}</span></div>
          <div className="quick-help"><button className="help-btn"><FontAwesomeIcon icon={faQuestionCircle} /></button></div>
        </div>
      </aside>

      <main className={`main-content ${activeSidePanel ? `side-panel-${sidePanelPosition}` : ''}`} ref={mainContentRef}>
        <div className="page-content">
          <Suspense fallback={<div className="loading-content"><div className="spinner"></div><p>{translations.loading || 'Loading...'}</p></div>}>
            {getActiveComponent()}
          </Suspense>
        </div>
        {user?.role !== 'customer' && !user?.role?.includes('supplier') && (
          <div className="quick-stats">
            <div className="stat-card"><div className="stat-icon"><FontAwesomeIcon icon={faCheckCircle} /></div><div className="stat-content"><h3>24</h3><p>{translations.todayTasks || 'Today\'s Tasks'}</p></div></div>
            <div className="stat-card"><div className="stat-icon"><FontAwesomeIcon icon={faChartLine} /></div><div className="stat-content"><h3>85%</h3><p>{translations.performance || 'Performance'}</p></div></div>
            <div className="stat-card"><div className="stat-icon"><FontAwesomeIcon icon={faClock} /></div><div className="stat-content"><h3>12</h3><p>{translations.pendingActions || 'Pending Actions'}</p></div></div>
            <div className="stat-card"><div className="stat-icon"><FontAwesomeIcon icon={faUsers} /></div><div className="stat-content"><h3>38</h3><p>{translations.activeUsers || 'Active Users'}</p></div></div>
          </div>
        )}
        {user?.role === 'customer' && (
          <div className="quick-stats customer-stats">
            <div className="stat-card"><div className="stat-icon"><FontAwesomeIcon icon={faShoppingBag} /></div><div className="stat-content"><h3>12</h3><p>{translations.myOrders || 'My Orders'}</p></div></div>
            <div className="stat-card"><div className="stat-icon"><FontAwesomeIcon icon={faClock} /></div><div className="stat-content"><h3>3</h3><p>{translations.paymentDue || 'Payment Due'}</p></div></div>
            <div className="stat-card"><div className="stat-icon"><FontAwesomeIcon icon={faTruckDelivery} /></div><div className="stat-content"><h3>2</h3><p>{translations.deliveryStatus || 'In Delivery'}</p></div></div>
            <div className="stat-card"><div className="stat-icon"><FontAwesomeIcon icon={faStar} /></div><div className="stat-content"><h3>5</h3><p>{translations.favoriteProducts || 'Favorites'}</p></div></div>
          </div>
        )}
        {user?.role?.includes('supplier') && (
          <div className="quick-stats supplier-stats">
            <div className="stat-card"><div className="stat-icon"><FontAwesomeIcon icon={faShoppingCart} /></div><div className="stat-content"><h3>45</h3><p>{translations.supplierOrders || 'New Orders'}</p></div></div>
            <div className="stat-card"><div className="stat-icon"><FontAwesomeIcon icon={faMoneyBillWave} /></div><div className="stat-content"><h3>$12.5k</h3><p>{translations.supplierPayments || 'Pending Payments'}</p></div></div>
            <div className="stat-card"><div className="stat-icon"><FontAwesomeIcon icon={faBoxes} /></div><div className="stat-content"><h3>156</h3><p>{translations.supplierProducts || 'Products'}</p></div></div>
            <div className="stat-card"><div className="stat-icon"><FontAwesomeIcon icon={faStar} /></div><div className="stat-content"><h3>4.8</h3><p>{translations.supplierRating || 'Rating'}</p></div></div>
            <div className="stat-card"><div className="stat-icon"><FontAwesomeIcon icon={faTruck} /></div><div className="stat-content"><h3>28</h3><p>{translations.supplierShipments || 'To Ship'}</p></div></div>
            <div className="stat-card"><div className="stat-icon"><FontAwesomeIcon icon={faExclamationTriangle} /></div><div className="stat-content"><h3>3</h3><p>{translations.supplierLowStock || 'Low Stock'}</p></div></div>
          </div>
        )}
      </main>

      {/* Refresh Toast Notification */}
      {refreshMessage && (
        <div className="refresh-toast">
          <FontAwesomeIcon icon={faCheckCircle} />
          <span>{refreshMessage}</span>
        </div>
      )}

      {/* Dynamic Side Panel */}
      {activeSidePanel && sidePanelComponent && (
        <SidePanel
          isOpen={true}
          onClose={() => {
            setActiveSidePanel(null);
            setSidePanelTitle('');
            setSidePanelComponent(null);
          }}
          title={sidePanelTitle}
          initialWidth={500}
        >
          <Suspense fallback={<div className="loading-content"><div className="spinner"></div><p>Loading...</p></div>}>
            {sidePanelComponent}
          </Suspense>
        </SidePanel>
      )}

      {/* Keyboard Shortcuts Popup */}
      {showShortcuts && (
        <div className="keyboard-shortcuts-popup" ref={shortcutsRef}>
          <div className="shortcuts-header">
            <h4>
              <FontAwesomeIcon icon={faKeyboard} />
              Keyboard Shortcuts - Mechanics Dashboard
            </h4>
            <button className="close-shortcuts" onClick={toggleShortcuts}>
              <FontAwesomeIcon icon={faTimes} />
            </button>
          </div>
          <div className="shortcuts-list">
            {shortcuts.map((shortcut, index) => (
              <div key={index} className="shortcut-item">
                <span className="shortcut-key">{shortcut.key}</span>
                <span className="shortcut-description">{shortcut.description}</span>
              </div>
            ))}
          </div>
          <div className="shortcuts-footer">
            <small>Press Alt+H to toggle this panel | Press Esc to close | Press Ctrl+R to refresh data (preserves menu)</small>
          </div>
        </div>
      )}

      {/* Full Screen Shortcut Modal */}
      {shortcutModal.isOpen && (
        <div className="shortcut-modal-overlay" onClick={closeShortcutModal}>
          <div className="shortcut-modal-container" onClick={(e) => e.stopPropagation()}>
            <div className="shortcut-modal-header">
              <div className="shortcut-modal-title">
                <FontAwesomeIcon icon={faKeyboard} className="modal-title-icon" />
                <h3>{shortcutModal.title}</h3>
              </div>
              <button className="shortcut-modal-close" onClick={closeShortcutModal}>
                <FontAwesomeIcon icon={faTimes} />
              </button>
            </div>
            <div className="shortcut-modal-content">
              <Suspense fallback={
                <div className="modal-loading">
                  <div className="spinner"></div>
                  <p>Loading...</p>
                </div>
              }>
                {shortcutModal.component}
              </Suspense>
            </div>
            <div className="shortcut-modal-footer">
              <button className="modal-footer-btn" onClick={closeShortcutModal}>
                <FontAwesomeIcon icon={faTimes} /> Close (Esc)
              </button>
            </div>
          </div>
        </div>
      )}

      {showNotificationForm && (
        <div className="modal-overlay" onClick={() => setShowNotificationForm(false)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <NotificationForm onClose={() => setShowNotificationForm(false)} />
          </div>
        </div>
      )}

      {(showNotifications || showUserMenu || showThemePicker || showLanguagePicker || showShopSwitcher) && (
        <div className="dropdown-overlay" onClick={closeAllDropdowns} onTouchStart={closeAllDropdowns} style={{ pointerEvents: 'auto' }} />
      )}
    </div>
  );
};

export default DashboardSuperAdmin;